<div>
  <app-material-form (onSubmit)="closeDialog($event)" [budgetId]="data.budgetId" [subBudgetId]="data.subBudgetId" [type]="data.type"
  [material]="data.material"></app-material-form>
  </div>


// WEBPACK FOOTER //
// ./src/app/budget/sub-budget.component.ts.MaterialDialogComponent.html